import { ReactNode, Suspense } from 'react'

import { LoadingLazyRoutes } from '@/components/loading-lazy-routes'

interface LazyRouteProps {
  children: ReactNode
}

export function LazyRoute({ children }: LazyRouteProps) {
  return <Suspense fallback={<LoadingLazyRoutes />}>{children}</Suspense>
}
